import React from 'react';
import MyAccountPageShell from './MyAccountPageShell';

const MyAccountDownloads: React.FC = () => {
    return (
        <MyAccountPageShell
            title="Downloads"
            subtitle="Downloadable files linked to your account will appear here."
        >
            <p className="text-muted mb-0">No downloads available yet.</p>
        </MyAccountPageShell>
    );
};

export default MyAccountDownloads;
